// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f7fa;
  color: #333;
  line-height: 1.6;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header Styles */
.app-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
}

.header-text {
  text-align: left;
}

.app-header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.app-header p {
  font-size: 1.1rem;
  opacity: 0.9;
}

/* Layout */
.app-layout {
  display: flex;
  flex: 1 1;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.sidebar {
  width: 320px;
  background: white;
  padding: 2rem;
  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

.main-content {
  flex: 1 1;
  padding: 2rem;
  overflow-x: hidden;
}

/* Filter Controls */
.filter-controls {
  font-size: 0.95rem;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.filter-header h3 {
  color: #495057;
  font-size: 1.3rem;
}

.meeting-count {
  background: #667eea;
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.filter-group {
  margin-bottom: 1.5rem;
}

.filter-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #495057;
}

.search-input, .filter-select {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: border-color 0.2s ease;
}

.search-input:focus, .filter-select:focus {
  outline: none;
  border-color: #667eea;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.checkbox-label:hover {
  background-color: #f8f9fa;
}

.checkbox-label input[type="checkbox"] {
  margin-right: 0.75rem;
  transform: scale(1.2);
}

.checkbox-text {
  font-weight: 500;
}

.clear-filters-btn {
  width: 100%;
  padding: 0.75rem;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.clear-filters-btn:hover {
  background: #c82333;
}

/* Meeting List */
.meeting-list {
  max-width: 900px;
}

.meeting-list-empty {
  text-align: center;
  padding: 4rem 2rem;
}

.empty-state h3 {
  color: #6c757d;
  margin-bottom: 1rem;
}

.empty-state p {
  color: #adb5bd;
}

/* Month Sections */
.month-section {
  margin-bottom: 3rem;
}

.month-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 3px solid #667eea;
}

.month-title {
  color: #495057;
  font-size: 1.8rem;
  font-weight: 700;
}

.month-count {
  background: #f8f9fa;
  color: #6c757d;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

.month-meetings {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

/* Meeting Cards */
.meeting-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  border-left: 4px solid #e9ecef;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.meeting-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.12);
}

.meeting-card.eubat {
  border-left-color: #28a745;
}

.meeting-card.druid {
  border-left-color: #6f42c1;
}

.meeting-card.bard {
  border-left-color: #fd7e14;
}

.meeting-card.important {
  background: linear-gradient(135deg, #fff3cd 0%, #ffffff 100%);
  border-left-color: #ffc107;
}

.meeting-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.meeting-date {
  display: flex;
  flex-direction: column;
}

.meeting-date .date {
  font-size: 1.2rem;
  font-weight: 700;
  color: #495057;
}

.meeting-date .weekday {
  font-size: 0.9rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.meeting-time {
  background: #667eea;
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.meeting-main {
  space-y: 0.75rem;
}

.meeting-lodge {
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
}

.meeting-lodge strong {
  color: #495057;
}

.city {
  color: #6c757d;
  font-weight: normal;
}

.meeting-type {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.type-badge {
  background: #e9ecef;
  color: #495057;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.dresscode {
  background: #dc3545;
  color: white;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.meeting-special {
  margin-bottom: 0.75rem;
}

.meeting-badge {
  background: #6f42c1;
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
}

.meeting-details {
  color: #495057;
  font-style: italic;
  margin-bottom: 0.75rem;
  line-height: 1.5;
}

.meeting-place {
  color: #6c757d;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-layout {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    position: static;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
  
  .main-content {
    padding: 1rem;
  }
  
  .app-header {
    padding: 1.5rem;
  }
  
  .app-header h1 {
    font-size: 2rem;
  }
  
  .month-meetings {
    grid-template-columns: 1fr;
  }
  
  .meeting-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .filter-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}

@media (max-width: 480px) {
  .app-header {
    padding: 1rem;
  }
  
  .app-header h1 {
    font-size: 1.6rem;
  }
  
  .sidebar {
    padding: 1rem;
  }
  
  .meeting-card {
    padding: 1rem;
  }
}

/* ViewToggle Styles */
.view-toggle {
  display: flex;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  padding: 0.3rem;
  gap: 0.3rem;
}

.toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 20px;
  background: transparent;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.toggle-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.toggle-btn.active {
  background: white;
  color: #667eea;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.toggle-icon {
  font-size: 1rem;
}

/* Calendar View Styles */
.calendar-view {
  max-width: 1200px;
}

.calendar-view-empty {
  text-align: center;
  padding: 4rem 2rem;
}

.calendar-month {
  margin-bottom: 4rem;
}

.calendar-header {
  margin-bottom: 2rem;
  text-align: center;
}

.calendar-title {
  color: #495057;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #e9ecef;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.calendar-weekday {
  background: #495057;
  color: white;
  padding: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.calendar-day {
  background: white;
  min-height: 200px;
  padding: 0.5rem;
  position: relative;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
}

.calendar-day:hover {
  background: #f8f9fa;
}

.calendar-day.other-month {
  background: #f8f9fa;
  color: #adb5bd;
}

.calendar-day.today {
  background: linear-gradient(135deg, #fff3cd 0%, #ffffff 100%);
}

.calendar-day.has-meetings {
  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
}

.calendar-day.today.has-meetings {
  background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 20%, #ffffff 100%);
}

/* Special day backgrounds */
.calendar-day.has-samain {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
  border: 2px solid #1976d2;
}

.calendar-day.has-storloge {
  background: linear-gradient(135deg, #ffebee 0%, #ffffff 100%);
  border: 2px solid #e91e63;
}

.calendar-day.has-igld {
  background: linear-gradient(135deg, #f3e5f5 0%, #ffffff 100%);
  border: 2px solid #9c27b0;
}

.calendar-day.has-jarnbaraland {
  background: linear-gradient(135deg, #f3e5f5 0%, #ffffff 100%);
  border: 2px solid #7b1fa2;
}

.calendar-day.has-folkungaland {
  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
  border: 2px solid #388e3c;
}

/* Combined special meeting days */
.calendar-day.has-samain.has-storloge,
.calendar-day.has-samain.has-igld,
.calendar-day.has-samain.has-jarnbaraland,
.calendar-day.has-samain.has-folkungaland,
.calendar-day.has-storloge.has-igld,
.calendar-day.has-storloge.has-jarnbaraland,
.calendar-day.has-storloge.has-folkungaland,
.calendar-day.has-igld.has-jarnbaraland,
.calendar-day.has-igld.has-folkungaland,
.calendar-day.has-jarnbaraland.has-folkungaland {
  background: linear-gradient(135deg, #fff3e0 0%, #ffcc80 30%, #ffffff 100%);
  border: 2px solid #ff9800;
}

.calendar-day.many-meetings {
  font-weight: bold;
}

.day-number {
  font-weight: 700;
  font-size: 1.1rem;
  color: #495057;
  margin-bottom: 0.5rem;
  text-align: center;
  flex-shrink: 0;
}

.calendar-day.other-month .day-number {
  color: #adb5bd;
}

.calendar-day.today .day-number {
  color: #856404;
  font-size: 1.2rem;
}

.day-meetings {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1 1;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #667eea #f1f1f1;
}

.day-meetings::-webkit-scrollbar {
  width: 4px;
}

.day-meetings::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.day-meetings::-webkit-scrollbar-thumb {
  background: #667eea;
  border-radius: 2px;
}

.day-meetings::-webkit-scrollbar-thumb:hover {
  background: #5a6fd8;
}


.calendar-day.many-meetings .meeting-item {
  padding: 0.2rem;
  font-size: 0.7rem;
}

.meeting-overflow {
  font-size: 0.6rem;
  color: #667eea;
  font-weight: 600;
  margin-left: 0.3rem;
}

.more-meetings-indicator {
  background: #667eea;
  color: white;
  padding: 0.1rem 0.3rem;
  border-radius: 8px;
  font-size: 0.6rem;
  font-weight: 600;
  text-align: center;
  margin-top: 0.1rem;
  cursor: pointer;
}

/* Meeting Item Styles (for calendar view) */
.meeting-item {
  background: white;
  border-radius: 6px;
  padding: 0.4rem;
  font-size: 0.75rem;
  border-left: 3px solid #e9ecef;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0.2rem;
}

.meeting-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.meeting-item.eubat {
  border-left-color: #28a745;
  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
}

.meeting-item.druid {
  border-left-color: #6f42c1;
  background: linear-gradient(135deg, #f3e8ff 0%, #ffffff 100%);
}

.meeting-item.bard {
  border-left-color: #fd7e14;
  background: linear-gradient(135deg, #fff3e0 0%, #ffffff 100%);
}

.meeting-item.important {
  background: linear-gradient(135deg, #fff3cd 0%, #ffffff 100%);
  border-left-color: #ffc107;
}

.meeting-item.special {
  background: linear-gradient(135deg, #ffebee 0%, #ffffff 100%);
  border-left-color: #e91e63;
  box-shadow: 0 2px 8px rgba(233, 30, 99, 0.2);
}

.meeting-item.samain {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
  border-left-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

.meeting-item.jarnbaraland {
  background: linear-gradient(135deg, #f3e5f5 0%, #ffffff 100%);
  border-left-color: #7b1fa2;
  box-shadow: 0 2px 8px rgba(123, 31, 162, 0.2);
}

.meeting-item.folkungaland {
  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
  border-left-color: #388e3c;
  box-shadow: 0 2px 8px rgba(56, 142, 60, 0.2);
}

/* Region identification borders */
.meeting-card.bardaland {
  border-bottom: 3px solid #667eea;
}

.meeting-card.jarnbaraland {
  border-bottom: 3px solid #7b1fa2;
}

.meeting-card.folkungaland {
  border-bottom: 3px solid #ffc107;
}

.meeting-item.bardaland {
  border-bottom: 2px solid #667eea;
}

.meeting-item.jarnbaraland {
  border-bottom: 2px solid #7b1fa2;
}

.meeting-item.folkungaland {
  border-bottom: 2px solid #ffc107;
}

.meeting-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;
}

.meeting-item-time {
  background: #667eea;
  color: white;
  padding: 0.1rem 0.4rem;
  border-radius: 10px;
  font-size: 0.65rem;
  font-weight: 600;
}

.dresscode-indicator {
  font-size: 0.8rem;
}

.meeting-item-lodge {
  font-weight: 700;
  color: #495057;
  margin-bottom: 0.2rem;
  line-height: 1.2;
}

.meeting-item-type {
  background: #28a745;
  color: white;
  padding: 0.1rem 0.3rem;
  border-radius: 8px;
  font-size: 0.6rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
  display: inline-block;
}

.meeting-item-special {
  background: #6f42c1;
  color: white;
  padding: 0.1rem 0.3rem;
  border-radius: 8px;
  font-size: 0.6rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
  display: inline-block;
}

.meeting-item-details {
  color: #6c757d;
  font-style: italic;
  margin-bottom: 0.2rem;
  line-height: 1.2;
}

.meeting-item-city {
  color: #6c757d;
  font-size: 0.65rem;
  font-weight: 500;
}

/* Responsive Calendar */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .header-text {
    text-align: center;
  }
  
  .calendar-day {
    min-height: 160px;
    padding: 0.3rem;
  }
  
  .calendar-weekday {
    padding: 0.5rem;
    font-size: 0.8rem;
  }
  
  .meeting-item {
    font-size: 0.7rem;
    padding: 0.3rem;
  }
  
  .meeting-item-time {
    font-size: 0.6rem;
  }
  
  
  .view-toggle {
    flex-direction: row;
    width: 100%;
    max-width: 300px;
  }
  
  .toggle-btn {
    flex: 1 1;
    justify-content: center;
    padding: 0.5rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .calendar-grid {
    grid-template-columns: repeat(7, 1fr);
    gap: 0.5px;
  }
  
  .calendar-day {
    min-height: 120px;
    padding: 0.2rem;
  }
  
  .day-number {
    font-size: 0.9rem;
    margin-bottom: 0.3rem;
  }
  
  .meeting-item {
    font-size: 0.65rem;
    padding: 0.2rem;
  }
  
  .meeting-item-lodge {
    font-size: 0.65rem;
  }
  
  .meeting-item-time {
    font-size: 0.55rem;
    padding: 0.05rem 0.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,0EAA0E;AAC5E;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;;;;;;;;;;EAUE,0EAA0E;EAC1E,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;EACP,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF","sourcesContent":["/* Reset and base styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f7fa;\n  color: #333;\n  line-height: 1.6;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header Styles */\n.app-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 2rem;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.header-text {\n  text-align: left;\n}\n\n.app-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n}\n\n.app-header p {\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n/* Layout */\n.app-layout {\n  display: flex;\n  flex: 1;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.sidebar {\n  width: 320px;\n  background: white;\n  padding: 2rem;\n  box-shadow: 2px 0 10px rgba(0,0,0,0.1);\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.main-content {\n  flex: 1;\n  padding: 2rem;\n  overflow-x: hidden;\n}\n\n/* Filter Controls */\n.filter-controls {\n  font-size: 0.95rem;\n}\n\n.filter-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.filter-header h3 {\n  color: #495057;\n  font-size: 1.3rem;\n}\n\n.meeting-count {\n  background: #667eea;\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.filter-group {\n  margin-bottom: 1.5rem;\n}\n\n.filter-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #495057;\n}\n\n.search-input, .filter-select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  transition: border-color 0.2s ease;\n}\n\n.search-input:focus, .filter-select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 6px;\n  transition: background-color 0.2s ease;\n}\n\n.checkbox-label:hover {\n  background-color: #f8f9fa;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin-right: 0.75rem;\n  transform: scale(1.2);\n}\n\n.checkbox-text {\n  font-weight: 500;\n}\n\n.clear-filters-btn {\n  width: 100%;\n  padding: 0.75rem;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.clear-filters-btn:hover {\n  background: #c82333;\n}\n\n/* Meeting List */\n.meeting-list {\n  max-width: 900px;\n}\n\n.meeting-list-empty {\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n.empty-state h3 {\n  color: #6c757d;\n  margin-bottom: 1rem;\n}\n\n.empty-state p {\n  color: #adb5bd;\n}\n\n/* Month Sections */\n.month-section {\n  margin-bottom: 3rem;\n}\n\n.month-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 3px solid #667eea;\n}\n\n.month-title {\n  color: #495057;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.month-count {\n  background: #f8f9fa;\n  color: #6c757d;\n  padding: 0.4rem 1rem;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.month-meetings {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n}\n\n/* Meeting Cards */\n.meeting-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n  border-left: 4px solid #e9ecef;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.meeting-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0,0,0,0.12);\n}\n\n.meeting-card.eubat {\n  border-left-color: #28a745;\n}\n\n.meeting-card.druid {\n  border-left-color: #6f42c1;\n}\n\n.meeting-card.bard {\n  border-left-color: #fd7e14;\n}\n\n.meeting-card.important {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffffff 100%);\n  border-left-color: #ffc107;\n}\n\n.meeting-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.meeting-date {\n  display: flex;\n  flex-direction: column;\n}\n\n.meeting-date .date {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #495057;\n}\n\n.meeting-date .weekday {\n  font-size: 0.9rem;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.meeting-time {\n  background: #667eea;\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.meeting-main {\n  space-y: 0.75rem;\n}\n\n.meeting-lodge {\n  font-size: 1.1rem;\n  margin-bottom: 0.75rem;\n}\n\n.meeting-lodge strong {\n  color: #495057;\n}\n\n.city {\n  color: #6c757d;\n  font-weight: normal;\n}\n\n.meeting-type {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.type-badge {\n  background: #e9ecef;\n  color: #495057;\n  padding: 0.2rem 0.6rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.dresscode {\n  background: #dc3545;\n  color: white;\n  padding: 0.2rem 0.6rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.meeting-special {\n  margin-bottom: 0.75rem;\n}\n\n.meeting-badge {\n  background: #6f42c1;\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.meeting-details {\n  color: #495057;\n  font-style: italic;\n  margin-bottom: 0.75rem;\n  line-height: 1.5;\n}\n\n.meeting-place {\n  color: #6c757d;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .app-layout {\n    flex-direction: column;\n  }\n  \n  .sidebar {\n    width: 100%;\n    position: static;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  }\n  \n  .main-content {\n    padding: 1rem;\n  }\n  \n  .app-header {\n    padding: 1.5rem;\n  }\n  \n  .app-header h1 {\n    font-size: 2rem;\n  }\n  \n  .month-meetings {\n    grid-template-columns: 1fr;\n  }\n  \n  .meeting-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .filter-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-header {\n    padding: 1rem;\n  }\n  \n  .app-header h1 {\n    font-size: 1.6rem;\n  }\n  \n  .sidebar {\n    padding: 1rem;\n  }\n  \n  .meeting-card {\n    padding: 1rem;\n  }\n}\n\n/* ViewToggle Styles */\n.view-toggle {\n  display: flex;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 25px;\n  padding: 0.3rem;\n  gap: 0.3rem;\n}\n\n.toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 20px;\n  background: transparent;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n}\n\n.toggle-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.toggle-btn.active {\n  background: white;\n  color: #667eea;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.toggle-icon {\n  font-size: 1rem;\n}\n\n/* Calendar View Styles */\n.calendar-view {\n  max-width: 1200px;\n}\n\n.calendar-view-empty {\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n.calendar-month {\n  margin-bottom: 4rem;\n}\n\n.calendar-header {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.calendar-title {\n  color: #495057;\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 1px;\n  background: #e9ecef;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n}\n\n.calendar-weekday {\n  background: #495057;\n  color: white;\n  padding: 1rem;\n  text-align: center;\n  font-weight: 700;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.calendar-day {\n  background: white;\n  min-height: 200px;\n  padding: 0.5rem;\n  position: relative;\n  transition: background-color 0.2s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.calendar-day:hover {\n  background: #f8f9fa;\n}\n\n.calendar-day.other-month {\n  background: #f8f9fa;\n  color: #adb5bd;\n}\n\n.calendar-day.today {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffffff 100%);\n}\n\n.calendar-day.has-meetings {\n  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);\n}\n\n.calendar-day.today.has-meetings {\n  background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 20%, #ffffff 100%);\n}\n\n/* Special day backgrounds */\n.calendar-day.has-samain {\n  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);\n  border: 2px solid #1976d2;\n}\n\n.calendar-day.has-storloge {\n  background: linear-gradient(135deg, #ffebee 0%, #ffffff 100%);\n  border: 2px solid #e91e63;\n}\n\n.calendar-day.has-igld {\n  background: linear-gradient(135deg, #f3e5f5 0%, #ffffff 100%);\n  border: 2px solid #9c27b0;\n}\n\n.calendar-day.has-jarnbaraland {\n  background: linear-gradient(135deg, #f3e5f5 0%, #ffffff 100%);\n  border: 2px solid #7b1fa2;\n}\n\n.calendar-day.has-folkungaland {\n  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);\n  border: 2px solid #388e3c;\n}\n\n/* Combined special meeting days */\n.calendar-day.has-samain.has-storloge,\n.calendar-day.has-samain.has-igld,\n.calendar-day.has-samain.has-jarnbaraland,\n.calendar-day.has-samain.has-folkungaland,\n.calendar-day.has-storloge.has-igld,\n.calendar-day.has-storloge.has-jarnbaraland,\n.calendar-day.has-storloge.has-folkungaland,\n.calendar-day.has-igld.has-jarnbaraland,\n.calendar-day.has-igld.has-folkungaland,\n.calendar-day.has-jarnbaraland.has-folkungaland {\n  background: linear-gradient(135deg, #fff3e0 0%, #ffcc80 30%, #ffffff 100%);\n  border: 2px solid #ff9800;\n}\n\n.calendar-day.many-meetings {\n  font-weight: bold;\n}\n\n.day-number {\n  font-weight: 700;\n  font-size: 1.1rem;\n  color: #495057;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.calendar-day.other-month .day-number {\n  color: #adb5bd;\n}\n\n.calendar-day.today .day-number {\n  color: #856404;\n  font-size: 1.2rem;\n}\n\n.day-meetings {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  flex: 1;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #667eea #f1f1f1;\n}\n\n.day-meetings::-webkit-scrollbar {\n  width: 4px;\n}\n\n.day-meetings::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 2px;\n}\n\n.day-meetings::-webkit-scrollbar-thumb {\n  background: #667eea;\n  border-radius: 2px;\n}\n\n.day-meetings::-webkit-scrollbar-thumb:hover {\n  background: #5a6fd8;\n}\n\n\n.calendar-day.many-meetings .meeting-item {\n  padding: 0.2rem;\n  font-size: 0.7rem;\n}\n\n.meeting-overflow {\n  font-size: 0.6rem;\n  color: #667eea;\n  font-weight: 600;\n  margin-left: 0.3rem;\n}\n\n.more-meetings-indicator {\n  background: #667eea;\n  color: white;\n  padding: 0.1rem 0.3rem;\n  border-radius: 8px;\n  font-size: 0.6rem;\n  font-weight: 600;\n  text-align: center;\n  margin-top: 0.1rem;\n  cursor: pointer;\n}\n\n/* Meeting Item Styles (for calendar view) */\n.meeting-item {\n  background: white;\n  border-radius: 6px;\n  padding: 0.4rem;\n  font-size: 0.75rem;\n  border-left: 3px solid #e9ecef;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 0.2rem;\n}\n\n.meeting-item:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.meeting-item.eubat {\n  border-left-color: #28a745;\n  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);\n}\n\n.meeting-item.druid {\n  border-left-color: #6f42c1;\n  background: linear-gradient(135deg, #f3e8ff 0%, #ffffff 100%);\n}\n\n.meeting-item.bard {\n  border-left-color: #fd7e14;\n  background: linear-gradient(135deg, #fff3e0 0%, #ffffff 100%);\n}\n\n.meeting-item.important {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffffff 100%);\n  border-left-color: #ffc107;\n}\n\n.meeting-item.special {\n  background: linear-gradient(135deg, #ffebee 0%, #ffffff 100%);\n  border-left-color: #e91e63;\n  box-shadow: 0 2px 8px rgba(233, 30, 99, 0.2);\n}\n\n.meeting-item.samain {\n  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);\n  border-left-color: #1976d2;\n  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);\n}\n\n.meeting-item.jarnbaraland {\n  background: linear-gradient(135deg, #f3e5f5 0%, #ffffff 100%);\n  border-left-color: #7b1fa2;\n  box-shadow: 0 2px 8px rgba(123, 31, 162, 0.2);\n}\n\n.meeting-item.folkungaland {\n  background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);\n  border-left-color: #388e3c;\n  box-shadow: 0 2px 8px rgba(56, 142, 60, 0.2);\n}\n\n/* Region identification borders */\n.meeting-card.bardaland {\n  border-bottom: 3px solid #667eea;\n}\n\n.meeting-card.jarnbaraland {\n  border-bottom: 3px solid #7b1fa2;\n}\n\n.meeting-card.folkungaland {\n  border-bottom: 3px solid #ffc107;\n}\n\n.meeting-item.bardaland {\n  border-bottom: 2px solid #667eea;\n}\n\n.meeting-item.jarnbaraland {\n  border-bottom: 2px solid #7b1fa2;\n}\n\n.meeting-item.folkungaland {\n  border-bottom: 2px solid #ffc107;\n}\n\n.meeting-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.3rem;\n}\n\n.meeting-item-time {\n  background: #667eea;\n  color: white;\n  padding: 0.1rem 0.4rem;\n  border-radius: 10px;\n  font-size: 0.65rem;\n  font-weight: 600;\n}\n\n.dresscode-indicator {\n  font-size: 0.8rem;\n}\n\n.meeting-item-lodge {\n  font-weight: 700;\n  color: #495057;\n  margin-bottom: 0.2rem;\n  line-height: 1.2;\n}\n\n.meeting-item-type {\n  background: #28a745;\n  color: white;\n  padding: 0.1rem 0.3rem;\n  border-radius: 8px;\n  font-size: 0.6rem;\n  font-weight: 600;\n  margin-bottom: 0.2rem;\n  display: inline-block;\n}\n\n.meeting-item-special {\n  background: #6f42c1;\n  color: white;\n  padding: 0.1rem 0.3rem;\n  border-radius: 8px;\n  font-size: 0.6rem;\n  font-weight: 600;\n  margin-bottom: 0.2rem;\n  display: inline-block;\n}\n\n.meeting-item-details {\n  color: #6c757d;\n  font-style: italic;\n  margin-bottom: 0.2rem;\n  line-height: 1.2;\n}\n\n.meeting-item-city {\n  color: #6c757d;\n  font-size: 0.65rem;\n  font-weight: 500;\n}\n\n/* Responsive Calendar */\n@media (max-width: 768px) {\n  .header-content {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .header-text {\n    text-align: center;\n  }\n  \n  .calendar-day {\n    min-height: 160px;\n    padding: 0.3rem;\n  }\n  \n  .calendar-weekday {\n    padding: 0.5rem;\n    font-size: 0.8rem;\n  }\n  \n  .meeting-item {\n    font-size: 0.7rem;\n    padding: 0.3rem;\n  }\n  \n  .meeting-item-time {\n    font-size: 0.6rem;\n  }\n  \n  \n  .view-toggle {\n    flex-direction: row;\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .toggle-btn {\n    flex: 1;\n    justify-content: center;\n    padding: 0.5rem;\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .calendar-grid {\n    grid-template-columns: repeat(7, 1fr);\n    gap: 0.5px;\n  }\n  \n  .calendar-day {\n    min-height: 120px;\n    padding: 0.2rem;\n  }\n  \n  .day-number {\n    font-size: 0.9rem;\n    margin-bottom: 0.3rem;\n  }\n  \n  .meeting-item {\n    font-size: 0.65rem;\n    padding: 0.2rem;\n  }\n  \n  .meeting-item-lodge {\n    font-size: 0.65rem;\n  }\n  \n  .meeting-item-time {\n    font-size: 0.55rem;\n    padding: 0.05rem 0.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
